import { ArrowRepeatAllRegular } from '@fluentui/react-icons';
export const routinesModule = {
    path: 'rotinas',
    title: 'Rotinas',
    icon: ArrowRepeatAllRegular,
    placement: 'main',
    pages: [
        {
            path: 'agendamentos',
            title: 'Rotinas',
            description: 'Agende, execute e acompanhe o que o app faz sozinho.',
            icon: ArrowRepeatAllRegular,
            permission: 'Routines.Read',
            load: () => import('#src/modules/routines/RoutinesPage.js').then((m) => m.RoutinesPage),
        },
    ],
};
//# sourceMappingURL=routines.module.js.map